// extracted by mini-css-extract-plugin
export default {"mentionsMenu":"mentions-plugin_mentionsMenu__U40io","mentionItem":"mentions-plugin_mentionItem__z-qXI","selectedMentionItem":"mentions-plugin_selectedMentionItem__rMPFU"};